// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

export const toggleElement = <T>(arr: T[], val: T) => arr.includes(val) ? arr.filter(el => el !== val) : [...arr, val];